module.exports = __webpack_public_path__ + "img/fabriqblog-original-1920.39090245.webp";